import { render } from "./Share_Accounts.vue?vue&type=template&id=5768de41"
import script from "./Share_Accounts.vue?vue&type=script&lang=js"
export * from "./Share_Accounts.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__